// Build-time feature flags.
//
// EXPO_PUBLIC_POSTHOG_ENV is already baked into every web build by the compose
// files (production | testing | development), so flags derived from it need no
// extra env wiring.

const BUILD_ENV = process.env.EXPO_PUBLIC_POSTHOG_ENV;

// MCS preparation is still in progress: visible on testing/dev, hidden on production.
// To launch it on production, set this to `true`.
export const MCS_ENABLED = BUILD_ENV !== 'production';

// Admin debug quick actions ("Create test school", "Debug auth") call
// endpoints the backend 404s on production (ADM-7), so they only render on
// testing/dev builds.
export const ADMIN_DEBUG_ACTIONS_ENABLED = BUILD_ENV !== 'production';
